type GetHexColorCode = (colorName: string) => string;
type ColourCodes = { [key: string]: string };
// Check if this is needed or if we can use the product data for this
const colourCodes: ColourCodes = {
  topaz: '#ffc87c',
  mineral: '#3b5686',
  primrose: '#ff93be',
  dusk: '#5c777f',
  terra: '#e2725b',
  glacierwhite: '#ecf0f9',
  indigo: '#4b0082',
  leadgray: '#444f53',
  steelgray: '#7b9095',
  foggreen: '#d0c5a7',
  brie: '#f0e0c7',
  slate: '#708090',
  skygray: '#a5b7bd',
  blackink: '#383b3e',
  silver: '#C0C0C0',
  beige: '#F5F5DC',
  white: '#fff',
  black: '#000',
  jetblack: '#0A0A0A',
  chocolate: '#D2691E',
  mica: '#123d5a',
  willow: '#99CC66',
  sahara: '#d7af78',
  pebble: '#c3bca8',
  ivory: '#fffff0',
  Sand: '#c2b280',
  natural: '#ae4a60',
  plumpurple: '#9c51b6',
  petalpink: '#F4E9E6',
  fourleafclover: '#68b374',
  brightwhite: '#fff',
  crystal: '#a7d8de',
  birch: '#3f3726',
  marshmallow: '#f9f5ec',
  mint: '#3EB489',
  grayviolet: '#958f9d',
  shale: '#82979e',
  graphite: '#251607',
  espresso: '#4E2A2A',
  dove: '#666666',
  creamy: '#FFFDD0',
  marigold: '#eaa221',
  cottagewhite: '#f2e7d2',
  sand: '#c2b280',
  taupe : '#483C32'
};

const honeycombColourCodes: ColourCodes = {
  white: '#EDEDED',
  silver: '#939391',
  beige: '#BDAFA2',
  black: '#3A3A3A',
  taupe : '#483C32'
};

const curtainColourCodes: ColourCodes = {
  white: '#DAD8D9',
  silver: '#ABA9AA',
  black: '#2B2B2B',
  // Treat "no" track requirement as white for rendering purposes
  no: '#DAD8D9',
  taupe : '#483C32'
};

const rollerColourCodes: ColourCodes = {
  white: '#EDEDED',
  ivory: '#E4E1D3',
  black: '#3A3A3A',
  silver: '#939391',
  taupe : '#483C32'
};

const liningColourCodes: ColourCodes = {
  white: '#FFFFFF',
  taupe: '#483C32',
  beige: '#F5F5DC',
  cream: '#FFFDD0',
  ivory: '#FFFFF0',
  gray:"#808080",
  grey:"#808080",
  black:"#000000",
  anthracite:"#000000"

};

export const getHexColorCode: GetHexColorCode = colorName => {
  var colorNameSafe = colorName.toLowerCase().replace(/[\W_]+/g, '');
  return colourCodes[colorNameSafe] ? colourCodes[colorNameSafe] : colorName;
};

export const getHoneycombRailHexColour: GetHexColorCode = colorName => {
  var colorNameSafe = colorName.toLowerCase().replace(/[\W_]+/g, '');
  return honeycombColourCodes[colorNameSafe]
    ? honeycombColourCodes[colorNameSafe]
    : colorName;
};

export const getCurtainRailHexColour: GetHexColorCode = colorName => {
  var colorNameSafe = colorName.toLowerCase().replace(/[\W_]+/g, '');
  return curtainColourCodes[colorNameSafe]
    ? curtainColourCodes[colorNameSafe]
    : colorName;
};

export const getRollerHexColour: GetHexColorCode = colorName => {
  var colorNameSafe = colorName.toLowerCase().replace(/[\W_]+/g, '');
  return rollerColourCodes[colorNameSafe]
    ? rollerColourCodes[colorNameSafe]
    : colorName;
};

export const getLiningHexColour: GetHexColorCode = colorName => {
  var colorNameSafe = colorName.toLowerCase().replace(/[\W_]+/g, '');
  return liningColourCodes[colorNameSafe]
    ? liningColourCodes[colorNameSafe]
    : colorName;
};
